module.exports = __webpack_public_path__ + "static/media/Rebecca Lintow cropped_1694720753568.b5a7f0f1.jpg";